import React, { useEffect, useRef, useState } from 'react';
import './App.css';

const slides = [
  {
    img: 'https://dashscope-result-wlcb-acdr-1.oss-cn-wulanchabu-acdr-1.aliyuncs.com/1d/6a/20250624/37456d0e/50bee819-322a-4a7f-bd6f-d62197fcf7fa2692022981.png?Expires=1750836183&OSSAccessKeyId=LTAI5tKPD3TMqf2Lna1fASuh&Signature=oSUex3Q5CLpL0kGQYn3NXHRFFG4%3D',
    cn: <>欢迎来到 <span className="highlight">Colors!</span></>,
    en: 'Welcome to Colors!',
    audio: [
      'https://edudev.lunalabs.cn/sound/0e5a2e46-cda7-404d-bd56-412b558a56e5_0.wav',
      'https://edudev.lunalabs.cn/sound/c75e735e-ce5c-4153-9f66-80e3ec3c6af5_0.wav'
    ],
    audioContent:[
      "Hello! Hello! My name is Teacher Lily. What's your name?",
      "Today we will learn about colors! Red, Green, Blue, Yellow! Are you ready? Let's go!"
    ],
    content: "Welcome to Colors!"
  },
  {
    img: 'https://dashscope-result-wlcb-acdr-1.oss-cn-wulanchabu-acdr-1.aliyuncs.com/1d/de/20250624/37456d0e/5cd66ee8-c5af-45ad-9e95-96f0ac5005c12425554145.png?Expires=1750836208&OSSAccessKeyId=LTAI5tKPD3TMqf2Lna1fASuh&Signature=cgolCuOG%2B1TqzMud3ujBM8uX%2B0Q%3D',
    cn: <span className="highlight">红色</span>,
    en: 'red',
    audio: [
      'https://edudev.lunalabs.cn/sound/a40c81da-c167-4e75-98d6-76245937c6de_0.wav'
    ],
    audioContent: [
      "This is RED! Red, red! Say it with me: RED!"
    ],
    content: "This is RED! Red, red! Say it with me: RED! Good job!"
  },
  {
    img: 'https://dashscope-result-wlcb-acdr-1.oss-cn-wulanchabu-acdr-1.aliyuncs.com/1d/0c/20250624/37456d0e/ac76a456-1910-476a-8a42-187a3b0684ed1154055698.png?Expires=1750836223&OSSAccessKeyId=LTAI5tKPD3TMqf2Lna1fASuh&Signature=c5kDFuMHNNC5Am15FwT7yWWmtOw%3D',
    cn: <>一个<span className="highlight">红色</span>的苹果</>,
    en: 'a RED apple',
    audio: [
      'https://edudev.lunalabs.cn/sound/4e81009d-6bed-446b-8c0d-939283c5846b_0.wav',
      'https://edudev.lunalabs.cn/sound/1552e0c8-9c2c-4963-b9ee-b01eaa820bcd_0.wav'
    ],
    audioContent: [
      "This is a red apple. ",
      "Can you say: It's red.?"
    ],
    content: "This is a red apple. What color is it? It's RED! Can you say: It's red.?"
  }
];

const colorData = [
  { color: '#5751D5', data: [1, 2, 1, 3] },
  { color: '#E74C3C', data: [3, 2, 4, 1] },
  { color: '#27AE60', data: [2, 3, 2, 4] },
  { color: '#2980D9', data: [1, 4, 2, 3] },
  { color: '#F4D03F', data: [4, 1, 3, 2] },
  { color: '#5751D5', data: [2, 2, 3, 1] },
  { color: '#27AE60', data: [1, 3, 2, 2] },
  { color: '#E74C3C', data: [3, 1, 2, 4] },
  { color: '#5751D5', data: [2, 4, 1, 3] },
  { color: '#F4D03F', data: [1, 2, 4, 3] },
  { color: '#2980D9', data: [3, 2, 1, 4] },
  { color: '#5751D5', data: [2, 3, 1, 2] },
];

// 环境变量读取
const DEEPGRAM_API_KEY = process.env.REACT_APP_DEEPGRAM_API_KEY!;
const DIFY_API_KEY = process.env.REACT_APP_DIFY_API_KEY!;
const DIFY_API_URL = process.env.REACT_APP_DIFY_API_URL!;

function loadEcharts(cb: () => void) {
  if ((window as any).echarts) return cb();
  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/echarts@5.4.2/dist/echarts.min.js';
  script.onload = cb;
  document.body.appendChild(script);
}

function App() {
  const [current, setCurrent] = useState(0);
  const [autoMode, setAutoMode] = useState(false);
  const [currentAudioIdx, setCurrentAudioIdx] = useState(0);
  const audioRef = useRef<HTMLAudioElement>(null);
  const autoNextTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const chartRef = useRef<HTMLDivElement[]>([]);
  const [isRecording, setIsRecording] = useState(false);
  const [recorder, setRecorder] = useState<MediaRecorder | null>(null);
  const [recordedBlob, setRecordedBlob] = useState<Blob | null>(null);
  const [difyReply, setDifyReply] = useState('');
  const [replyAudioUrl, setReplyAudioUrl] = useState('');
  const [showRecordBtn, setShowRecordBtn] = useState(false);
  const [showNextBtn, setShowNextBtn] = useState(false);
  const replyAudioRef = useRef<HTMLAudioElement>(null);
  const [conversationId, setConversationId] = useState('');

  // 自动流程
  useEffect(() => {
    if (!autoMode) return;
    if (!audioRef.current) return;
    audioRef.current.currentTime = 0;
    audioRef.current.src = slides[current].audio[currentAudioIdx];
    audioRef.current.play();
    const onEnded = () => {
      if (autoNextTimeout.current) clearTimeout(autoNextTimeout.current);
      // 每个音频播放完后都显示录音按钮
      setShowRecordBtn(true);
      // 如果还有下一个音频，同时显示"继续播放下一个音频"按钮
      if (currentAudioIdx < slides[current].audio.length - 1) {
        setShowNextBtn(true);
      }
    };
    audioRef.current.addEventListener('ended', onEnded);
    return () => {
      if (audioRef.current) audioRef.current.removeEventListener('ended', onEnded);
      if (autoNextTimeout.current) clearTimeout(autoNextTimeout.current);
    };
  }, [current, autoMode, currentAudioIdx]);

  // ECharts渲染
  useEffect(() => {
    loadEcharts(() => {
      slides.forEach((slide, idx) => {
        const dom = chartRef.current[idx];
        if (dom && (window as any).echarts) {
          const chart = (window as any).echarts.init(dom);
          chart.setOption({
            backgroundColor: 'rgba(0,0,0,0)',
            xAxis: { show: false, type: 'category', data: ['A','B','C','D'] },
            yAxis: { show: false },
            series: [{
              data: colorData[idx].data,
              type: 'line',
              smooth: true,
              lineStyle: { color: colorData[idx].color, width: 6, shadowBlur: 16, shadowColor: colorData[idx].color },
              areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [ { offset: 0, color: colorData[idx].color }, { offset: 1, color: 'rgba(87,81,213,0)' } ] } }
            }]
          });
        }
      });
    });
  }, []);

  // 动画效果
  useEffect(() => {
    if (!(window as any).anime) {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/animejs@3.2.1/lib/anime.min.js';
      script.onload = () => triggerAnime();
      document.body.appendChild(script);
    } else {
      triggerAnime();
    }
    function triggerAnime() {
      (window as any).anime && (window as any).anime({
        targets: '.parallax',
        translateY: [80, 0],
        opacity: [0, 1],
        duration: 900,
        easing: 'easeOutExpo'
      });
    }
  }, [current]);

  // 鼠标滚轮/键盘切换
  useEffect(() => {
    if (autoMode) return;
    const onWheel = (e: WheelEvent) => {
      if (e.deltaY > 0 && current < slides.length - 1) setCurrent(current + 1);
      else if (e.deltaY < 0 && current > 0) setCurrent(current - 1);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { if (current < slides.length - 1) setCurrent(current + 1); }
      if (e.key === 'ArrowUp' || e.key === 'PageUp') { if (current > 0) setCurrent(current - 1); }
    };
    window.addEventListener('wheel', onWheel);
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('keydown', onKey);
    };
  }, [current, autoMode]);

  // 录音相关函数
  function startRecording() {
    setShowRecordBtn(false); // 隐藏录音按钮
    console.log('准备开始录音...');
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      const mediaRecorder = new MediaRecorder(stream);
      setRecorder(mediaRecorder);
      setIsRecording(true);
      let chunks: BlobPart[] = [];
      mediaRecorder.ondataavailable = e => chunks.push(e.data);
      mediaRecorder.onstop = () => {
        const blob = new Blob(chunks, { type: 'audio/webm' });
        setRecordedBlob(blob);
        setIsRecording(false);
        console.log('录音结束，音频数据已获取', blob);
        // 录音结束后，调用识别
        recognizeWithDeepgram(blob);
      };
      mediaRecorder.start();
      console.log('录音已开始');
      // 录音 5 秒后自动停止
      setTimeout(() => {
        if (mediaRecorder.state !== 'inactive') {
          mediaRecorder.stop();
          console.log('录音自动停止');
        }
      }, 3000);
    }).catch(err => {
      setIsRecording(false);
      setShowRecordBtn(true);
      console.error('录音失败', err);
      alert('无法访问麦克风，请检查权限设置');
    });
  }

  // Deepgram 语音识别
  async function recognizeWithDeepgram(blob: Blob) {
    console.log('开始调用Deepgram识别...');
    const response = await fetch('https://api.deepgram.com/v1/listen?smart_format=true&filler_words=true&model=nova-2', {
      method: 'POST',
      headers: {
        'Authorization': `Token ${DEEPGRAM_API_KEY}`,
        'Content-Type': 'audio/webm'
      },
      body: blob
    });
    const result = await response.json();
    const transcript = result.results?.channels?.[0]?.alternatives?.[0]?.transcript || '';
    console.log('Deepgram识别结果:', transcript);
    if (transcript) {
      sendToDify(slides[current].content,slides[current].audioContent[currentAudioIdx], transcript);
    } else {
      alert('未识别到语音内容，请重试');
      setShowRecordBtn(true);
      setShowNextBtn(true);
      // sendToDify(slides[current].content, "yellow");
    }
  }

  // Dify chat-messages
  async function sendToDify(currentContent: string, teacherQuestion: string, text: string) {
    console.log('发送到Dify:', currentContent);
    console.log('发送到Dify:', teacherQuestion);
    console.log('发送到Dify:', text);
    const response = await fetch(DIFY_API_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${DIFY_API_KEY}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        inputs: {"currentContent": currentContent, "teacherQuestion": teacherQuestion},
        query: text,
        response_mode: 'blocking',
        conversation_id: conversationId || '',
        user: 'test-user',
        files: []
      })
    });
    const data = await response.json();
    // 保存 conversation_id
    if (data.conversation_id) {
      setConversationId(data.conversation_id);
    }
    const reply = data.answer || data.choices?.[0]?.message?.content || '';
    setDifyReply(reply);
    console.log('Dify回复:', reply);
    if (reply) {
      getDoubaoAudio(reply);
    } else {
      alert('Dify未返回内容');
      setShowRecordBtn(true);
    }
  }

  // 豆包语音合成
  async function getDoubaoAudio(text: string) {
    setShowRecordBtn(false);
    setShowNextBtn(false);
    console.log('发送到火山TTS:', text);
    const response = await fetch('https://edudev.lunalabs.cn/api/tts', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text })
    });

    if (!response.ok) {
      alert('TTS请求失败');
      return;
    }

    const audioBlob = await response.blob();
    const audioUrl = URL.createObjectURL(audioBlob);
    setReplyAudioUrl(audioUrl);
    if (replyAudioRef.current) {
      replyAudioRef.current.pause();
      replyAudioRef.current.currentTime = 0;
      replyAudioRef.current.src = audioUrl;
      replyAudioRef.current.oncanplaythrough = () => {
        replyAudioRef.current?.play().catch(e => {
          console.warn('Audio play interrupted:', e);
        });
      };
    }
  }

  // 音频播放结束后显示按钮
  useEffect(() => {
    const audio = replyAudioRef.current;
    if (!audio) return;
    const onEnded = () => {
      setShowRecordBtn(true);
      setShowNextBtn(true);
    };
    audio.addEventListener('ended', onEnded);
    return () => {
      audio.removeEventListener('ended', onEnded);
    };
  }, [replyAudioRef]);

  // 下一页按钮功能
  function goToNextSlide() {
    setShowRecordBtn(false);
    setShowNextBtn(false);
    setCurrent((prev) => (prev < slides.length - 1 ? prev + 1 : prev));
  }

  // 下一音频按钮
  function playNextAudio() {
    setShowRecordBtn(false); // 播放下一个音频时，隐藏录音按钮
    setShowNextBtn(false);
    setCurrentAudioIdx(idx => idx + 1);
  }

  // 切换slide时重置音频索引
  useEffect(() => {
    setCurrentAudioIdx(0);
  }, [current]);

  return (
    <div className="bg-main min-h-screen" style={{ background: '#FDFDFD' }}>
      <div id="slides">
        {slides.map((slide, idx) => (
          <section
            className={`section${idx === current ? ' active' : ''}`}
            key={idx}
            style={{ display: idx === current ? 'block' : 'none', minHeight: '100vh', padding: '2rem', position: 'relative' }}
          >
            <div className="flex flex-row items-center gap-12">
              <img src={slide.img} className="img-hero parallax" alt="slide visual" style={{ width: '60%', maxWidth: 480, minWidth: 220, borderRadius: '2rem', boxShadow: '0 8px 32px rgba(87,81,213,0.18)' }} />
              <div>
                <div className="big-cn mb-2" style={{ fontSize: '3rem', fontWeight: 900, color: '#161615', lineHeight: 1.1 }}>{slide.cn}</div>
                <div className="en-sub" style={{ fontSize: '1.2rem', color: '#5751D5', fontWeight: 500 }}>{slide.en}</div>
                {/* <button className="audio-btn" style={{ background: '#5751D5', color: '#fff', borderRadius: '50%', width: '3rem', height: '3rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', marginTop: '1rem', boxShadow: '0 2px 8px #5751d540' }} onClick={() => { if (audioRef.current) { audioRef.current.currentTime = 0; audioRef.current.play(); } }}><i className="fas fa-volume-up"></i></button> */}
                {idx === 0 && !autoMode && (
                  <button className="btn-main mt-12" style={{ background: '#161615', color: '#fff', fontSize: '1.5rem', fontWeight: 'bold', borderRadius: '2rem', padding: '0.75rem 2.5rem', marginTop: '2rem', boxShadow: '0 2px 12px #16161530' }} onClick={() => setAutoMode(true)}>开始课程 Start</button>
                )}
                {/* 录音按钮，仅在自动模式且音频播放完后显示 */}
                {autoMode && showRecordBtn && (
                  <button className="btn-main mt-6" style={{ background: '#E74C3C', color: '#fff', fontSize: '1.2rem', fontWeight: 'bold', borderRadius: '1.5rem', padding: '0.5rem 2rem', marginTop: '1.5rem', boxShadow: '0 2px 8px #E74C3C30' }} onClick={startRecording} disabled={isRecording}>
                    {isRecording ? '录音中...' : '开始录音'}
                  </button>
                )}
                {/* 继续播放下一个音频按钮 */}
                {autoMode && showNextBtn && (
                  <button className="btn-main mt-6" style={{ background: '#27AE60', color: '#fff', fontSize: '1.2rem', fontWeight: 'bold', borderRadius: '1.5rem', padding: '0.5rem 2rem', marginTop: '1.5rem', boxShadow: '0 2px 8px #27AE6030' }} onClick={playNextAudio}>
                    继续播放下一个音频
                  </button>
                )}
                <button className="btn-main mt-6" style={{ background: '#E74C3C', color: '#fff', fontSize: '1.2rem', fontWeight: 'bold', borderRadius: '1.5rem', padding: '0.5rem 2rem', marginTop: '1.5rem', boxShadow: '0 2px 8px #E74C3C30' }} onClick={goToNextSlide}>下一页</button>
              </div>
            </div>
            {/* <div className="echart-box mt-8" ref={el => chartRef.current[idx] = el!} style={{ width: 320, height: 120, margin: '0 auto' }} /> */}
          </section>
        ))}
        <audio ref={audioRef} src={slides[current].audio[currentAudioIdx]} />
        {/* 用于播放豆包语音回复 */}
        <audio ref={replyAudioRef} src={replyAudioUrl} />
        {showRecordBtn && (
          <button onClick={startRecording}>开始录音</button>
        )}
        {showNextBtn && (
          <button onClick={playNextAudio}>继续播放下一个音频</button>
        )}
        {showNextBtn && (
          <button onClick={goToNextSlide}>下一页</button>
        )}
      </div>
    </div>
  );
}

export default App;
